import React, { useEffect, useState, useRef } from 'react';
import api from '../../Services/api';
import axios from 'axios';
import { COLORS } from '../colors';
import '../EditableCard.css';
import MonthlyReport from '../MonthlyReport';
import { TextField,Button,MenuItem,Menu} from '@mui/material';
import { BiUpload } from 'react-icons/bi';
import { Link ,useNavigate,useLocation} from 'react-router-dom';
import SnackbarContent from '@mui/material/SnackbarContent';
import Snackbar from '@mui/material/Snackbar';
 import { FaFileDownload } from "react-icons/fa";
import { MdFileOpen, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";
import index from '../../Pages/Dashboard';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const months = [
    { name: "JANUARY", value: "01" },
    { name: "FEBRUARY", value: "02" },
    { name: "MARCH", value: "03" },
    { name: "APRIL", value: "04" },
    { name: "MAY", value: "05" },
    { name: "JUNE", value: "06" },
    { name: "JULY", value: "07" },
    { name: "AUGUST", value: "08" },
    { name: "SEPTEMBER", value: "09" },
    { name: "OCTOBER", value: "10" },
    { name: "NOVEMBER", value: "11" },
    { name: "DECEMBER", value: "12" }
];
const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
const titles = [
    "The Contract Labour (Regulation & Abolition) Act, 1970",
    "Generic",
    "Minimum Wages Act, 1936",
    "The Employee's Provident Funds & Miscellaneous Provisions Act and Scheme, 1952",
    "The Employees' State Insurance Act and Regulations, 1948",
    "Professional Tax",
    "The Payment of Bonus Act, 1972",
    "Shops And Commercial Establishments Act",
    "The Maternity Benefit Act, 1961",
    "The Employees Compensation Act, 1923",
    "The Equal Remuneration Act, 1976",
    "The Factories Act, 1948",
    "The Labour Welfare Fund Act, 1965",
     "Notice from Govt Bodies"

];
const titleToKeyMap = {
    "Combined Muster Roll-cum-Register of Wages": "combinedMusterRollCumRegisterOfWages",
    "Register of Workmen": "RegisterOfWorkmen",
    "Leave Register/Leave Book": "leaveRegisterLeaveBook",
    "Employment Card": "EmploymentCard",
    "Wage Slip": "WageSlip",
    "Service Certificate for Left Employees": "ServiceCertificateForLeftEmployees",
    "In and out time Register": "inAndOutTimeRegister",
    "Bank Statement for Salary Credit Confirmation": "BankStatementOrSalaryCreditConfirmation",
    "PF Declaration on letterhead": "PFDeclarationOnLetterhead",
    "ESI Declaration on letterhead": "ESIDeclarationOnLetterhead",
    "Overtime Declaration on letterhead": "OvertimeDeclarationOnLetterhead",
    "Payment done as per revised rate of Minimum wages": "PaymentDoneAsPerRevisedRateOfMinimumwages",
    "PF Monthly ECR": "PFMonthlyECR",
    "PF Combined Challan": "PFCombinedChallan",
    "PF TRRN Summary": "PFTRRNSummary",
    "IW-1 International Worker Monthly Returns": "IW1InternationalWorkerMonthlyReturns",
    "ESI-Accident Register": "ESIAccidentRegister",
    "ESIC Contribution Challan": "ESICContributionChallan",
    "ESIC Monthly Statement": "ESICMonthlyStatement",
    "Pehchan Card (Insured Person)": "PehchanCard",
    "Professional Tax Returns": "professionalTaxReturns",
    "PT Challan": "PTChallan",
    "Monthly Bonus Paid or Not": "MonthlyBonusPaidOrNot",
    "Statutory Bonus Return": "statutoryBonusReturn",
    "Registration Of Establishment": "registrationOfEstablishment",
    "Appointment Order In Form Q": "appointmentOrderInFormQ",
    "Muster Roll Of Women Workers": "musterRollOfWomenWorkers",
    "Employees Compensation Policy": "employeesCompensationPolicy",
    "Equal Remuneration And Register To Be Maintained": "EqualRemunerationAndRegisterToBeMaintained",
    "Register of Overtime and Payment": "RegisterofOvertimeandPayment",
    "Register Of Leave And Leave Book": "RegisterOfLeaveAndLeaveBook",
    "Register Of Adult Workers Cum Muster Roll": "RegisterOfAdultWorkersCumMusterRoll",
    "Combined register for Muster Roll and Wages": "CombinedregisterforMusterRollandWages",
    "Register Of Unclaimed Wages And Payment To The Board": "RegisterOfUnclaimedWagesAndPaymentToTheBoard",
    "LWF Challan": "LWFChallan",
    "Pending Notice From Govt Bodies":"PendingNoticeFromGovtBodies"







};



const preferredSubTitles = {
    "The Contract Labour (Regulation & Abolition) Act, 1970": [
        { subtitle: "Combined Muster Roll-cum-Register of Wages" },
        { subtitle: "Register of Workmen" },
        { subtitle: "Leave Register/Leave Book" },
        { subtitle: "Employment Card" },
        { subtitle: "Wage Slip" },
        { subtitle: "Service Certificate for Left Employees" }
    ],
    "Generic": [
        { subtitle: "In and out time Register" },
        { subtitle: "Bank Statement for Salary Credit Confirmation" },
        { subtitle: "PF Declaration on letterhead" },
        { subtitle: "ESI Declaration on letterhead" },
        { subtitle: "Overtime Declaration on letterhead" }
    ],
    "Minimum Wages Act, 1936": [
        { subtitle: "Payment done as per revised rate of Minimum wages" }
    ],
    "The Employee's Provident Funds & Miscellaneous Provisions Act and Scheme, 1952": [
        { subtitle: "PF Monthly ECR" },
        { subtitle: "PF Combined Challan" },
        { subtitle: "PF TRRN Summary" },
        { subtitle: "IW-1 International Worker Monthly Returns" }
    ],
    "The Employees' State Insurance Act and Regulations, 1948": [
        { subtitle: "ESI-Accident Register" },
        { subtitle: "ESIC Contribution Challan" },
        { subtitle: "ESIC Monthly Statement" },
        { subtitle: "Pehchan Card (Insured Person)" }
    ],
    "Professional Tax": [
        { subtitle: "Professional Tax Returns" },
        { subtitle: "PT Challan" }
    ],
    "The Payment of Bonus Act, 1972": [
        { subtitle: "Monthly Bonus Paid or Not" },
        { subtitle: "Statutory Bonus Return" }
    ],
    "Shops And Commercial Establishments Act": [
        { subtitle: "Registration Of Establishment" },
        { subtitle: "Appointment Order In Form Q" }
    ],
    "The Maternity Benefit Act, 1961": [
        { subtitle: "Muster Roll Of Women Workers" }
    ],
    "The Employees Compensation Act, 1923": [
        { subtitle: "Employees Compensation Policy" }
    ],
    "The Equal Remuneration Act, 1976": [
        { subtitle: "Equal Remuneration And Register To Be Maintained" }
    ],
    "The Factories Act, 1948": [
        { subtitle: "Register of Overtime and Payment" },
        { subtitle: "Register Of Leave And Leave Book" },
        { subtitle: "Register Of Adult Workers Cum Muster Roll" },
        { subtitle: "Combined register for Muster Roll and Wages" }
    ],
    "The Labour Welfare Fund Act, 1965": [
        { subtitle: "Register Of Unclaimed Wages And Payment To The Board" },
        { subtitle: "LWF Challan" }
    ],
    "Notice from Govt Bodies": [

        {subtitle: "Pending Notice From Govt Bodies", risk:"High"}

 

    ],
};

const MonthlyDataTableAssessor = () => {
    const location = useLocation();
    
    const [loadedFromNavigation, setLoadedFromNavigation] = useState(false);
    const [objectivesOfTheAudit, setObjectivesOfTheAudit] = useState('');
    const [auditorObservation, setAuditorObservation] = useState('');
    const [auditorRecommendation, setAuditorRecommendation] = useState('');
    const [checkboxChanged, setCheckboxChanged] = useState({});
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState(null);
    const [userType, setUserType] = useState('');
    const [clients, setClients] = useState([]);
    const [assessors, setAssessors] = useState([]);
    const [vendorId,setVendorId]=useState('');
    const [vendors, setVendors] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [monthlyData, setMonthlyData] = useState({});
    const [complianceFiledDate, setComplianceFiledDate] = useState('')
    const [saveEnabled, setSaveEnabled] = useState({});
    const [selectedVendor, setSelectedVendor] = useState('');
    const [selectedAssessor, setSelectedAssessor] = useState('');
    const [isSaved, setIsSaved] = useState(false);
    const[savedStatus,setSavedStatus] = useState({});
    const[savedStatusObserv,setSavedStatusObserv]=useState(false);
    const filterStatus = Number(sessionStorage.getItem("validationFilter"));
    // const fileInputRefs = useRef(Array(titles.length * Math.max(...Object.values(preferredSubTitles).map(arr => arr.length))).fill(null).map(() => React.createRef()));
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState(''); // State to control the modal visibility
    const[selectedVendorDetails,setSelectedVendorDetails] = useState('');
    const [showModal, setShowModal] = useState(false);  
    const [uploadStatuses, setUploadStatuses] = useState({});
    const handleShow = () => setShowModal(true); 
    const handleClose = () => setShowModal(false);
    const[loading,setLoading] = useState(true)
    const [viewedDocs, setViewedDocs] = useState({});
    const [cancelledOnce, setCancelledOnce] = useState({}); 
  const [openedDocs, setOpenedDocs] = useState({});

const [menuAnchorEl, setMenuAnchorEl] = useState(null);
const [activeRemarkIndex, setActiveRemarkIndex] = useState(null);
const [editableRemarks, setEditableRemarks] = useState({}); 
const suggestionOptions = ["Verified Ok", "InComplete", "Wrong document", "OverDue", "Other"];

    useEffect(() => {
        const data = sessionStorage.getItem('user');
        let name = JSON.parse(data);
        let type = name.type;
        setUserType(type);
        let id = name.id;
     
        if (type === 'assessor') {
            fetchVendor(id);
        }
        else if (type === 'admin') {
            fetchClient(id);
        }
    
    }, [userType]);

    useEffect(() => {

        if (selectedVendor && selectedMonth && selectedYear) {
            fetchVendorData(selectedVendor, selectedMonth, selectedYear);
        }
      
    }, [selectedVendor, selectedMonth, selectedYear]);
   
    useEffect(() => {
        if (location.state) {
          const { selectedVendor, month, year ,status} = location.state;
      
          if (selectedVendor && month && year) {
            setSelectedVendor(selectedVendor);
            setSelectedMonth(month);
            setSelectedYear(year);
            fetchVendorDetails(selectedVendor); // Optional
            fetchVendorData(selectedVendor, month, year,status);
          }
        }
        else {
            sessionStorage.removeItem('selectedVendorId');
            sessionStorage.removeItem('validationFilter');
            setSelectedVendor('');
            setSelectedMonth('');
            setSelectedYear('');
          
          }
      }, [location.state]);

useEffect(() => {
  if (location.state && !loadedFromNavigation) {
    const { selectedVendor, month, year } = location.state;
    if (selectedVendor && month && year) {
        sessionStorage.setItem('selectedVendorId', selectedVendor);
      setSelectedVendor(selectedVendor);
      setVendorId(selectedVendor)
      setSelectedMonth(month);
      setSelectedYear(year);
      fetchVendorDetails(selectedVendor);
      fetchVendorData(selectedVendor, month, year);
      setLoadedFromNavigation(true);
    }
   
  }
}, [location.state]);

  

useEffect(() => {
  if (!loadedFromNavigation && selectedVendor && selectedMonth && selectedYear) {
    fetchVendorData(selectedVendor, selectedMonth, selectedYear);
  }
}, [selectedVendor, selectedMonth, selectedYear]);


  

const openSuggestionMenu = (subtitle) => (e) => {
  setActiveRemarkIndex(subtitle);
  setMenuAnchorEl(e.currentTarget);
};

const closeSuggestionMenu = () => {
  setMenuAnchorEl(null);
  setActiveRemarkIndex(null);
};
const handleSuggestionSelect = (subtitle, option) => {
  if (option === "Other") {
    // allow editing
    setEditableRemarks((prev) => ({ ...prev, [subtitle]: true }));
    handleRemarkChange(subtitle, ""); // reset for manual entry
  } else {
    // lock editing
    setEditableRemarks((prev) => ({ ...prev, [subtitle]: false }));
    handleRemarkChange(subtitle, option);
  }
  closeSuggestionMenu();
};


  
  
    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
        sessionStorage.removeItem("validationFilter")

    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
        sessionStorage.removeItem("validationFilter")

    };

    const fetchClient = async (id) => {
        try {
            const response = await api.client.getClients(id);
            if(response.status === 200){
                const clientData = response.data;
                setClients(clientData);
                setLoading(false)
            }
            else if(response.status === 500){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setClients([]);
                setLoading(false)
            }
            else{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Some error occured, please try again later");
                setClients([]);
                setAssessors([]);
                setVendors([]);
                setLoading(false)
            }
        } catch (error) {
            console.error("error");
        }
    }

    const fetchAssessorData = async (companyId) => {
        try {
            const response = await api.assessor.getassessor(companyId);
            if(response.status === 200){
            const assessorData = response.data.data;
            setAssessors(assessorData);
            }
            else if(response.status === 400){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setAssessors([]);
                setVendors([]);
                
                
            }
            else if(response.status === 404){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setAssessors([]);
                setVendors([])
            }
            else if(response.status === 500){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setAssessors([]);
                setVendors([]);
                setClients([]);
            }

        } catch (error) {
            console.error("error");
        }
    }

    const fetchVendor = async (assessorId) => {

        try {
            const response = await api.vendor.getVendors(assessorId);
            if(response.status === 200){
            const vendorData = response.data.data;
            setVendors(vendorData);
            setLoading(false);
            }
            else if(response.status === 400){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setVendors([])
                setLoading(false);
            }
            else if(response.status === 404){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setVendors([])
                setLoading(false);
            }
            else if(response.status === 500){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setVendors([])
                setLoading(false);
            }
            else{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Some error occured, please try again")
                setVendors([])
                setLoading(false);
            }
        } catch (error) {
            console.error("Vendor ID could not be fetched:", error);
        }
    };

    const handleClientChange = async (event) => {
        const companyId = event.target.value;
        setSelectedClient(companyId);
        setSelectedAssessor(''); 
        setSelectedVendor('');    
        setAssessors([]);          
        setVendors([]); 
        setSelectedMonth('');
        setSelectedYear(null);
        setMonthlyData({});
        setComplianceFiledDate('');
        setSelectedVendorDetails('');
        fetchAssessorData(companyId);
        setObjectivesOfTheAudit('');
        setAuditorObservation('');
        setAuditorRecommendation('');
        setSavedStatus(true)

        setSaveEnabled(false)

    };
    const handleAssessorChange = async (event) => {
        const assessorId = event.target.value;
        setSelectedAssessor(assessorId);
        setSelectedVendor('');    
        setVendors([]); 
        setSelectedMonth('');
        setSelectedYear(null);
        setMonthlyData({});
        setSelectedVendorDetails('');
        setComplianceFiledDate('')
        fetchVendor(assessorId);
        setObjectivesOfTheAudit('');
        setAuditorObservation('');
        setSavedStatus(true)
        setSaveEnabled(false)
    
        

    };
    const handleVendorChange = async (event) => {
        const vendorId = event.target.value;
        sessionStorage.setItem('selectedVendorId', vendorId);
        setSelectedVendor(vendorId);
        setVendorId(vendorId);
        fetchVendorDetails(vendorId);
        setObjectivesOfTheAudit('');
        setAuditorObservation('');
        setAuditorRecommendation('');
        setSavedStatus(true)
        setSaveEnabled(false)
        sessionStorage.removeItem("validationFilter")
        
    };
    const handleNaChange = (subtitle) => {
            const key = titleToKeyMap[subtitle];
            const updatedData = { ...monthlyData };
           
            updatedData[key] = {
                ...updatedData[key],
                na: !updatedData[key]?.na,  // Toggle the 'NA' status
                vendorRemark: '',   
                file: '',  
             
            };
        
            setMonthlyData(updatedData);
            setSaveEnabled((prev) => ({
                ...prev,
                [titleToKeyMap[subtitle]]: true,  // Enable the save button
            }));
            setSavedStatus((prev) => ({
                ...prev,
                [titleToKeyMap[subtitle]]: false,  // Mark as unsaved
            }));
            setUploadStatuses((prevStatus) => ({
                ...prevStatus,
               [subtitle]: 'Upload',
            }));
        
           
        };
        
        const fileInputRefs = useRef(
            titles.map((title) =>
              preferredSubTitles[title].map(() => React.createRef()) // Create a ref for each subtitle within a title
            )
          );
          const handleFileChange = (subtitle) => (event) => {
            console.log(subtitle)
            const files = event.target.files;
            const file = files[0];
            const key = titleToKeyMap[subtitle];
            console.log(key,"names")
            const updatedData = { ...monthlyData };
     
            if (file) {
                updatedData[key] = {
                    ...updatedData[key],
                    file: file.name,
                    selectedFile: file,
                    vendorRemark: '',
                };
                setUploadStatuses((prevStatus) => ({
                    ...prevStatus,
                    [subtitle]: 'Upload',
                }));
                setSavedStatus(prev => ({
                    ...prev,
                    [titleToKeyMap[subtitle]]: false,  // Mark as saved
                }));
    
                setSaveEnabled(prev => ({
                    ...prev,
                    [titleToKeyMap[subtitle]]: false,  // Disable save after saving
                }));
             
            } else {
                updatedData[key] = {
                    ...updatedData[key],
                    file: '',
                    selectedFile: '',
                };
               
            }
            setMonthlyData(updatedData);
        };

    const fetchVendorDetails = async (vendorId) => {
        try {
          const response = await api.vendor.fetchVendorDetailsById(vendorId);
          setSelectedVendorDetails(response.data.data);
          console.log(response.data.data);
         
        } catch (error) {
          console.error('Error fetching vendor data:', error);
        }
      }

    const fetchVendorData = async (vendorId, month, year) => {
        try {
            const response = await api.vendor.getMonthlyData(vendorId, month, year);
            if (response.status === 200) {
                const data = response.data.data || {};
                setObjectivesOfTheAudit(data.objectivesOfTheAudit);
                setAuditorObservation(data.auditorObservation);
                setAuditorRecommendation(data.auditorRecommendation);

                setComplianceFiledDate(data.complianceFiledDate);
                const remarks = collectRemarksByKey(data);
                setAuditorObservation(remarks); 
                if (data.objectivesOfTheAudit!='' || data.auditorObservation!='' || data.auditorRecommendation!='') {
                    // Set saved status to true if any of the fields are non-empty
                    setSavedStatusObserv(true);
                } else {
                    setSavedStatusObserv(false);
                }
                const initializedData = {};
                const newSavedStatus = {}
                Object.keys(data).forEach((key) => {
                    const entry = data[key];
                    initializedData[key] = {
                        fileUrl: entry.fileUrl || '',
                        validation: entry.validation !== null ? entry.validation : 0,
                        remark: entry.remark || '',
                        vendorRemark: entry.vendorRemark || '',
                        na: entry.na || false
                    };
                    if (entry.validation === 2 || entry.validation === 3) {
                        newSavedStatus[key] = true; 
                    } else {
                        newSavedStatus[key] = false; 
                    }
                });
                setMonthlyData(initializedData);
                setSavedStatus(newSavedStatus);
           
            }
            else if(response.status === 400){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setSelectedYear(null);
                setSelectedMonth('');
                setMonthlyData({});
                setSelectedDate(null);
                setComplianceFiledDate('')
                setSavedStatus(false)
                setSaveEnabled(false)
                setObjectivesOfTheAudit('');
                setAuditorObservation('');
                setAuditorRecommendation('');
                setSavedStatusObserv(false);
       
            }
            else if (response.status === 404) {
               setErrorSnackbarOpen(true);
               setSnackbarErrorMessage(response.data.message);
                setSelectedYear(null);
                setSelectedMonth('');
                setMonthlyData({});
                setSelectedDate(null);
                setComplianceFiledDate('')
                setSavedStatus(false)
                setSaveEnabled(false)
                setObjectivesOfTheAudit('');
                setAuditorObservation('');
                setAuditorRecommendation('');
                setSavedStatusObserv(false);

            }
            else if(response.status === 500){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setSelectedYear(null);
                setSelectedMonth('');
                setMonthlyData({});
                setSelectedDate(null);
                setComplianceFiledDate('')
                setSavedStatus(false)
                setSaveEnabled(false)
                setObjectivesOfTheAudit('');
                setAuditorObservation('');
                setAuditorRecommendation('');
                setSavedStatusObserv(false);
            }
            else{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Some error occured, please try again later");
                setSelectedYear(null);
                setSelectedMonth('');
                setMonthlyData({});
                setSelectedDate(null);
                setComplianceFiledDate('')
                setSavedStatus(false)
                setSaveEnabled(false)
                setObjectivesOfTheAudit('');
                setAuditorObservation('');
                setAuditorRecommendation('');
                setSavedStatusObserv(false);
        
            }

        } catch (error) {
            console.error('Error fetching monthly data', error);
        }
    };

    const collectRemarksByKey = (data) => {
        const remarks = [];
        let count = 1;  // Initialize a counter
        Object.keys(data).forEach((key) => {
            const entry = data[key];
            if (entry.remark) {
                remarks.push(`${count}. ${entry.remark}`);  // Add the count before the remark
                count++;  // Increment the counter
            }
        });
        setSavedStatusObserv(false)
        return remarks.join('\n');  
    };
    
    const handleCheckboxChange = (subtitle, action,fileUrl,index) => {
         if (fileUrl && !openedDocs[index]) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage("Please view the document before accepting or rejecting");
    return;
  }
         const key = titleToKeyMap[subtitle];
  const previousValidation = monthlyData[key]?.validation;
  
  
        const isAccepted = action === 'accept';
        const isRejected = action === 'reject';
    
       
        
        // Prepare updated data
        const updatedData = { ...monthlyData[key] };
        let validationChanged = false;
    
        if (isAccepted) {
            const newValidation = updatedData.validation === 2 ? 1 : 2;
            validationChanged = updatedData.validation !== newValidation;
            updatedData.validation = newValidation;
            updatedData.remark = '  Verified Ok';
        } else if (isRejected) {
            const newValidation = updatedData.validation === 3 ? 1 : 3;
            validationChanged = updatedData.validation !== newValidation;
            updatedData.validation = newValidation;
            updatedData.remark = '';
        }
    
        // Update checkbox change tracker
        setCheckboxChanged(prev => ({
            ...prev,
            [subtitle]: validationChanged,
        }));
    
        // Update monthly data
        setMonthlyData(prev => ({
            ...prev,
            [key]: updatedData,
        }));
    
        // Always disable saved status
        setSavedStatus(prev => ({
            ...prev,
            [key]: false,
        }));
    
        // Decide whether to enable save button
        const isRemarkEmpty = updatedData.remark === '';
        const saveEnabledValue =
            (updatedData.validation === 2) || // Accept always enables save
            (updatedData.validation === 3 && !isRemarkEmpty); // Reject only enables if remark is present
    
        setSaveEnabled(prev => ({
            ...prev,
            [key]: validationChanged && saveEnabledValue, // <-- final condition
        }));
    };
    
    
    
    
    const getRemark = (subtitle) => {
        const entry = { ...monthlyData[titleToKeyMap[subtitle]] } || {};
        return entry.remark || '';
    };
    
    const handleRemarkChange = (subtitle, newRemark) => {
        const updatedData = { ...monthlyData[titleToKeyMap[subtitle]] };
        updatedData.remark = newRemark; // Update the remark
    
        setMonthlyData({
            ...monthlyData,
            [titleToKeyMap[subtitle]]: updatedData
        });
     setSavedStatus(prev => ({
            ...prev,
              [titleToKeyMap[subtitle]]: false,
        }));
        // Enable Save if the remark is entered and validation is "Rejected" (3), and checkbox has changed
        setSaveEnabled(prev => ({
            ...prev,
            [titleToKeyMap[subtitle]]: 
                (updatedData.validation === 3 && newRemark !== '') || // Enable Save if "Rejected" and remark entered
                (updatedData.validation === 2 ), // Enable Save if "Accepted" and checkbox changed
        }));
         
    };
    
    const handleViewDoc =(subtitle,fileUrl,index)=>{
     setOpenedDocs(prev => ({ ...prev, [index]: true }));

         window.open(`https://docs.google.com/gview?url=${fileUrl}&embedded=true`, "_blank");
  setViewedDocs(prev => ({ ...prev, [subtitle]: true }));


    }
    
    
    
    function handleEnterKey(event, textareaId) {
        const textarea = document.getElementById(textareaId);

        if (event.key === "Enter") {
            event.preventDefault();

            const cursorPosition = textarea.selectionStart;
            const textBefore = textarea.value.substring(0, cursorPosition);
            const textAfter = textarea.value.substring(cursorPosition);
            textarea.value = `${textBefore}\n• ${textAfter}`;
            textarea.selectionStart = textarea.selectionEnd = cursorPosition + 3;
            textarea.focus();
        }
    }

    function insertBullet(textareaId) {
        const textarea = document.getElementById(textareaId);
        const cursorPosition = textarea.selectionStart;
        const textBefore = textarea.value.substring(0, cursorPosition);
        const textAfter = textarea.value.substring(cursorPosition);
        textarea.value = `${textBefore}• ${textAfter}`;
        textarea.selectionStart = textarea.selectionEnd = cursorPosition + 2;
        textarea.focus();
    }


   
    const handleSave = async (subtitle) => {
     
        const id = sessionStorage.getItem('selectedVendorId');
        
        const updatedEntry = monthlyData[titleToKeyMap[subtitle]] || {};
        const remarks = collectRemarksByKey(monthlyData);
        setAuditorObservation(remarks);
        const Monthlydata = {
            vendorId: id,
            month: selectedMonth,
            year: selectedYear,
            complianceFiledDate: complianceFiledDate,
            objectivesOfTheAudit: objectivesOfTheAudit || "",
            auditorObservation: auditorObservation || "",
            auditorRecommendation: auditorRecommendation || "",
        };

        const key = titleToKeyMap[subtitle];
        if (key) {
            Monthlydata[key] = {
                fileUrl: updatedEntry.fileUrl,
                validation: updatedEntry.validation,
                remark: updatedEntry.remark,
                vendorRemark: updatedEntry.vendorRemark,
                na: updatedEntry.na

            };
        }

        try {
            const response = await api.vendor.updateMonthlyData(Monthlydata);
            if (response.status === 200) {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
               setSavedStatusObserv(true);
                setSavedStatus(prev => ({
                    ...prev,
                    [titleToKeyMap[subtitle]]: true,  
                }));
                setSaveEnabled(prev => ({
                    ...prev,
                    [titleToKeyMap[subtitle]]: false,  
                }));
                try {
               
                      // console.log('Calling assessorToMail with payload:', payload);
                      const response = await api.assessor.assessorMailToVendorMonthlyData({vendorId:id,month:selectedMonth,year:selectedYear});
              
                      if (response.status === 200) {

                          setTimeout(()=>{
                        setSnackbarOpen(true);
                        setSnackbarMessage(response.data.message);
                          },2000)
                            setOpenedDocs(prev => ({ ...prev, [index]: false }));

  setViewedDocs(prev => ({ ...prev, [subtitle]: false }));
                      }
                      else if(response.status === 400){
                         setTimeout(()=>{
                        setErrorSnackbarOpen(true);
                        setSnackbarErrorMessage(response.data.message);
                         },2000)
                      }
                      
                       else if(response.status === 500){
                        setTimeout(()=>{
                        setErrorSnackbarOpen(true);
                        setSnackbarErrorMessage(response.data.message);
                        },2000)
                      } else {
                        setErrorSnackbarOpen(true);
                        setSnackbarErrorMessage(response.data.message);
                      }
                    } catch (emailErr) {
                      console.error('assessorToMail error:', emailErr);
                      setErrorSnackbarOpen(true);
                      setSnackbarErrorMessage(emailErr?.response?.data?.message);
                    }
            }
            else if (response.status === 404) {
 setErrorSnackbarOpen(true);
                setSnackbarMessage("Monthly data not found for selected month and year")
            }
            else if(response.status === 400){
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Please select the Vendor, month, year");
            }
            else if(response.status === 500){
setErrorSnackbarOpen(true);
setSnackbarErrorMessage(response.data.message);
            }
        } catch (error) {
            console.error('Error saving monthly data', error);
        }
    };

    const renderRows = () => {
        const validationFilterRaw = sessionStorage.getItem("validationFilter");
        const validationFilter = validationFilterRaw ? parseInt(validationFilterRaw) : null;
      
        return titles.map((title, titleIndex) => {
          const allSubtitles = preferredSubTitles[title];
          const rowsToRender = allSubtitles.filter(({ subtitle }) => {
            const validation = monthlyData[titleToKeyMap[subtitle]]?.validation;
          
            // Show the row if there's no filter
            if (validationFilter === null) return true;
          
            // Always show the row if user is editing it
            if (checkboxChanged[subtitle]) return true;
          
            // Otherwise apply the filter
            return validation === validationFilter;
          });
          
        
      
          if (validationFilter !== null && rowsToRender.length === 0) return true;
      
          return (
            <React.Fragment key={titleIndex}>
              <tr style={{ backgroundColor: COLORS.bggray }}>
                <td colSpan={6} className='fw-bold bg-light'>{title}</td>
              </tr>
              {rowsToRender.map(({ subtitle }, subtitleIndex) => {
                const dataEntry = monthlyData[titleToKeyMap[subtitle]] || {};
                const {
                  validation = 0,
                  remark = '',
                  vendorRemark = '',
                  fileUrl = '',
                  na = false,
                } = dataEntry;
                const fileInputRef = fileInputRefs.current[titleIndex][subtitleIndex];
                const rowStyle =
                  validation === 2 ? { backgroundColor: 'lightgreen' } :
                  validation === 3 ? { backgroundColor: 'lightcoral' } :
                  validation === 1 ? { backgroundColor: COLORS.bggray } :
                  { backgroundColor: 'transparent' };
      
                return (
                  <tr key={subtitleIndex} style={rowStyle}>
                    <td>{subtitle}</td>
      
                    <td>
                      {fileUrl ? (
                        <div className="mt-2 d-flex justify-center gap-3">
                          <button className='flex flex-col items-center text-sm text-green-700' onClick={() => handleViewDoc(subtitle,fileUrl,index)}>
<MdFileOpen className="text-xl text-success" /> View
</button>
                          <a  download className="flex flex-col items-center text-sm text-blue-700" href={fileUrl}>
                          <FaFileDownload className="text-xl text-primary" />Download
                          </a>
                        </div>
                      ) : na ? (
                        <span>Not Applicable</span>
                      ) : (
                        <span>Not Uploaded</span>
                      )}
                    </td>
      
                    <td>
                      <label>
                        <input type="checkbox" checked={validation === 2} onChange={() => handleCheckboxChange(subtitle, 'accept',fileUrl,index)} /> Accept
                      </label>
                      <label className="mx-2">
                        <input type="checkbox" checked={validation === 3} onChange={() => handleCheckboxChange(subtitle, 'reject',fileUrl,index)} /> Reject
                      </label>
                    </td>
      
                    <td>
  <div style={{ position: 'relative' }}>
                        
                      <textarea
                      className='p-2'
                        value={remark}
                        placeholder="Enter your remarks here"
                        onChange={(e) => handleRemarkChange(subtitle, e.target.value)}
                        rows="2"
                          readOnly={!editableRemarks[subtitle]} 
                        style={{ width: '100%' }}
                      />
                       <button
      type="button"
      onClick={openSuggestionMenu(subtitle)}
      style={{
        position: 'absolute',
        right: 10,
        bottom: 8,
        fontSize: 15,
        color: 'blue',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
      }}
    >
     <ArrowDropDownIcon/>
    </button>
     </div>
                      {vendorRemark && (
                        <div className="p-1" style={{ overflow: 'auto', width: '400px', height: '80px', border: '1px solid lightgray', color: 'red' }}>
                          vendor remark: {vendorRemark}
                        </div>
                      )}
                     
                    </td>
                    
   {/* Filter suggestion options based on current row validation */}
{(() => {
  let filteredSuggestions = suggestionOptions;

  if (validation === 2) {
    // ✅ Accepted → show only Verified Ok and Other
    filteredSuggestions = ["Verified Ok", "Other"];
  } else if (validation === 3) {
    // ❌ Rejected → show all except Verified Ok
    filteredSuggestions = suggestionOptions.filter(opt => opt !== "Verified Ok");
  }

  return (
    <Menu
      anchorEl={menuAnchorEl}
      open={activeRemarkIndex === subtitle}
      onClose={closeSuggestionMenu}
    >
      {filteredSuggestions.map((opt) => (
        <MenuItem
          key={opt}
          onClick={() => handleSuggestionSelect(subtitle, opt)}
          style={{ fontSize: "13px", padding: "4px 12px" }}
        >
          {opt}
        </MenuItem>
      ))}
    </Menu>
  );
})()}


                    <td>
                      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <button
                          className="btn btn-md btn-outline-dark"
                          onClick={() => handleSave(subtitle)}
                          disabled={!saveEnabled[titleToKeyMap[subtitle]]}
                        >
                          {savedStatus[titleToKeyMap[subtitle]] ? "Saved" : "Save"}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </React.Fragment>
          );
        });
      };
      
    const renderDropdowns = () => {
        if (userType === 'admin') {
            return (



                <div className="d-flex pt-4 w-100 justify-end">

                    <select className="mx-1 p-1" value={selectedClient || ''} onChange={handleClientChange} style={{minWidth:'250px',maxWidth:'300px',border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}}>
                        <option value="" disabled>Select Establishment</option>
                        {clients.map(client => (
                            <option key={client.companyId} value={client.companyId}>
                                {client.clientName} {client.stateId}
                            </option>
                        ))}
                    </select>
                    <select className="mx-1 p-1" value={selectedAssessor || ''} onChange={handleAssessorChange} style={{minWidth:'250px',maxWidth:'300px',border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}}>
                        <option value="" disabled>Select Assessor</option>
                        {Array.isArray(assessors) && assessors.map((assessor) => (
                            <option key={assessor.assessorId} value={assessor.assessorId}>
                                {assessor.assessorCompanyName} {assessor.site}
                            </option>
                        ))}
                    </select>
                    <select  className="mx-1 p-1" value={selectedVendor || ''} onChange={handleVendorChange} style={{minWidth:'250px',maxWidth:'300px',border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}}>
                        <option value="" disabled>Select Vendor</option>
                        {vendors && vendors.map(vendor => (
                            <option key={vendor.vendorId} value={vendor.vendorId}>
                                {vendor.vendorCompanyName}, {vendor.vendorStateId}
                            </option>
                        ))}
                    </select>
                    <select  className="mx-1 p-1" value={selectedMonth || ''} onChange={handleMonthChange} style={{borderRadius:'4px',border:'1px solid lightgray', cursor:'pointer'}}>
                        <option value="" disabled>Select Month</option>
                        {months.map((month) => (
                            <option key={month.value} value={month.value}>
                                {month.name}
                            </option>
                        ))}
                    </select>
                    <select className=" p-1" value={selectedYear || ''} onChange={handleYearChange} style={{borderRadius:'4px',border:'1px solid lightgray', cursor:'pointer'}}>
                        <option value="" disabled>Select Year</option>
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>

                </div>

            );
        } else {
            return (

                <div className='d-flex w-100 justify-end'>

                    <select className='p-1 mx-1' value={selectedVendor || ''} onChange={handleVendorChange} style={{borderRadius:'4px',minWidth:'250px',maxWidth:'300px',border:'1px solid lightgray', cursor:'pointer'}}>
                        <option value="" disabled>Select Vendor</option>
                        {vendors && vendors.map(vendor => (
                            <option key={vendor.vendorId} value={vendor.vendorId}>
                                {vendor.vendorCompanyName}, {vendor.vendorStateId}
                            </option>
                        ))}
                    </select>

                    <select className='p-1 mx-1'  value={selectedMonth || ''} onChange={handleMonthChange} style={{borderRadius:'4px',border:'1px solid lightgray', cursor:'pointer'}}>
                        <option value="" disabled>Select Month</option>
                        {months.map((month) => (
                            <option key={month.value} value={month.value}>
                                {month.name}
                            </option>
                        ))}
                    </select>
                    <select  className='p-1 mx-1' value={selectedYear || ''} onChange={handleYearChange} style={{borderRadius:'4px',border:'1px solid lightgray', cursor:'pointer'}}>
                        <option value="" disabled>Select Year</option>
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
 

                </div>


            );
        }
    };
    return (
        <>
      <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',

                }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                sx={{
                    marginTop: '2.9%',
                    marginRight: '7%'
                }}
            >
                <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
            </Snackbar>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                severity="error"
                open={errorSnackbarOpen}
                autoHideDuration={2000}
                sx={{
                    marginTop: '2.9%',
                    marginRight: '7%'
                }}
                onClose={() => { setErrorSnackbarOpen(false) }}
            >
                <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
            </Snackbar>
     
    
        {loading ? (
            <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
                  <h3>Loading</h3>
  <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
  <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
  <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>

</div>
) : 
userType === 'assessor' ? (
    vendors.length > 0 ? (
        <>
            <div className='px-3 pt-3 pb-3' >
                <div style={{ backgroundColor: COLORS.bggray, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
                <span style={{ fontSize: '14px' }}>Under review</span>
                <div className="vr  mx-3"></div>
                <div style={{ backgroundColor: COLORS.success, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
                <span style={{ fontSize: '14px' }}>Accepted</span>
                <div className="vr mx-3"></div>
                <div style={{ backgroundColor: COLORS.danger, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
                <span style={{ fontSize: '14px' }}>Rejected</span>
                <div className="d-flex mt-0 flex-wrap justify-content-right gap-2 ">
                    {renderDropdowns()}
                </div>
            </div>
          
            <div className="mt-0" style={{ maxHeight: "400px", marginTop:"10px", overflowY: "auto" }}>
                <table className="mt-0 pt-0" style={{ width: "100%"}}>
                    <thead className="position-sticky top-0" style={{ zIndex: 10, backgroundColor: "inherit" }}>
                        <tr className="text-white bg-dark">
                            <th>Title</th>
                            {/* <th>To Upload</th> */}
                            <th>Uploaded File</th>
                            <th>Actions</th>
                            <th>Observation</th>
                            <th>Action</th>

                        </tr>
                    </thead>
                    <tbody>
                    {selectedVendorDetails && (
  <div>
    <h6 className='p-3'>
 Nature of Work:<span className='fw-bold'> {selectedVendorDetails.natureOfWork}</span>
 </h6>
  </div>
)}

        {complianceFiledDate && (
              <section className='d-flex px-3 pb-3 d-flex gap-3 '>
    <div>
  {complianceFiledDate ? `Compliance Filed Date: ${complianceFiledDate.slice(0, 10).split('-').reverse().join('-')}` : ""}
</div>
<div>
<button className='flex flex-row items-center gap-1 text-sm text-danger' onClick={handleShow}>
       <MdFileOpen className="text-xl text-danger" /> View Report
    </button>
    </div>
    </section>     
)}
                        {renderRows()}
                    </tbody>
                    {/* <tr >
                        <td colSpan="4">
                            <textarea
                                value={objectivesOfTheAudit}
                                onChange={(e) => {setObjectivesOfTheAudit(e.target.value);
                                    setSavedStatusObserv(false)}}
                                style={{ width: '100%', height: '80px' }}
                                placeholder="Objective Of the Audit"
                            />

                        </td>
                        <td colSpan="2">
                            <button className='btn btn-success btn-md' style={{ position: 'relative', top: '50px' }} onClick={() => handleSave('objectivesOfTheAudit')} disabled={savedStatusObserv}>{savedStatusObserv?'Saved':'Save'}</button>
                        </td>
                    </tr> */}
                    <tr>

                        <td colSpan="2">
                            <div style={{ position: 'relative' }}>


                                <i className="fa fa-list-ul" onClick={() => insertBullet('observationTextarea')}></i>

                                <textarea
                                className='p-2'
                                    id="observationTextarea"
                                    value={auditorObservation}
                                    onChange={(e) => {setAuditorObservation(e.target.value)
                                        setSavedStatusObserv(false)}
                                    }
                                    style={{ width: '100%', height: '80px' }}
                                    placeholder="Enter Auditor Observation"
                                    onKeyDown={(e) => handleEnterKey(e, 'observationTextarea')}
                                />

                            </div>
                        </td>
                        <td colSpan="2">
                            <div style={{ position: 'relative' }}>
                                <i className="fa fa-list-ul" onClick={() => insertBullet('recommendationTextarea')}></i>

                                <textarea
                                  className='p-2'
                                    id="recommendationTextarea"
                                    value={auditorRecommendation}
                                    onChange={(e) =>{setAuditorRecommendation(e.target.value)
                                    setSavedStatusObserv(false)}
                                    }
                                    style={{ width: '100%', height: '80px' }}
                                    placeholder="Enter Auditor Recommendation"
                                    onKeyDown={(e) => handleEnterKey(e, 'recommendationTextarea')}
                                />

                            </div>
                        </td>

                    </tr>

                </table>
            </div>
       
        </> )  : (
             <div style={{ marginTop: '60px' }}>
                  <p className="text-center text-dark">
                    No Vendors Found !! <Link to="/createVendor" className="text-danger">Click here</Link> to Create
                  </p>
                </div>
        )
    ) : (
        <>
        <div className='px-3 pt-3 pb-3' >
            <div style={{ backgroundColor: COLORS.bggray, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
            <span style={{ fontSize: '14px' }}>Under review</span>
            <div className="vr  mx-3"></div>
            <div style={{ backgroundColor: COLORS.success, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
            <span style={{ fontSize: '14px' }}>Accepted</span>
            <div className="vr mx-3"></div>
            <div style={{ backgroundColor: COLORS.danger, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
            <span style={{ fontSize: '14px' }}>Rejected</span>
            <div className="d-flex mt-0 flex-wrap justify-content-right gap-2 ">
                {renderDropdowns()}
            </div>
        </div>
      
        <div className="mt-0" style={{ maxHeight: "400px", marginTop:"10px", overflowY: "auto" }}>
            <table className="mt-0 pt-0" style={{ width: "100%"}}>
                <thead className="position-sticky top-0" style={{ zIndex: 10, backgroundColor: "inherit" }}>
                    <tr className="text-white bg-dark">
                        <th>Title</th>
                        {/* <th>To Upload</th> */}
                        <th>Uploaded File</th>
                        <th>Actions</th>
                        <th>Observation</th>
                        <th>Action</th>

                    </tr>
                </thead>
                <tbody>
                {selectedVendorDetails && (
<div >
<h6 className='p-3'>
Nature of Work:<span className='fw-bold'> {selectedVendorDetails.natureOfWork}</span>
</h6>
</div>
)}

    {complianceFiledDate && (
          <section className='d-flex px-3 pb-3 d-flex gap-3'>
<div>
{complianceFiledDate ? `Compliance Filed Date: ${complianceFiledDate.slice(0, 10).split('-').reverse().join('-')}` : ""}
</div>
<button className='flex flex-row items-center gap-1 text-sm text-danger' onClick={handleShow}>
      <MdFileOpen className="text-xl text-danger" /> View Report
</button>
</section>     
)}
                    {renderRows()}
                </tbody>
                {/* <tr >
                    <td colSpan="4">
                        <textarea
                            value={objectivesOfTheAudit}
                            onChange={(e) => {setObjectivesOfTheAudit(e.target.value);
                                setSavedStatusObserv(false)}}
                            style={{ width: '100%', height: '80px' }}
                            placeholder="Objective Of the Audit"
                        />

                    </td>
                    <td colSpan="2">
                        <button className='btn btn-success btn-md' style={{ position: 'relative', top: '50px' }} onClick={() => handleSave('objectivesOfTheAudit')} disabled={savedStatusObserv}>{savedStatusObserv?'Saved':'Save'}</button>
                    </td>
                </tr> */}
                <tr>

                    <td colSpan="2">
                        <div style={{ position: 'relative' }}>


                            <i className="fa fa-list-ul" onClick={() => insertBullet('observationTextarea')}></i>

                            <textarea
                              className='p-2'
                                id="observationTextarea"
                                value={auditorObservation}
                                onChange={(e) => {setAuditorObservation(e.target.value)
                                    setSavedStatusObserv(false)}
                                }
                                style={{ width: '100%', height: '80px' }}
                                placeholder="Enter Auditor Observation"
                                onKeyDown={(e) => handleEnterKey(e, 'observationTextarea')}
                            />

                        </div>
                    </td>
                    <td colSpan="2">
                        <div style={{ position: 'relative' }}>
                            <i className="fa fa-list-ul" onClick={() => insertBullet('recommendationTextarea')}></i>

                            <textarea
                              className='p-2'
                                id="recommendationTextarea"
                                value={auditorRecommendation}
                                onChange={(e) =>{setAuditorRecommendation(e.target.value)
                                setSavedStatusObserv(false)}
                                }
                                style={{ width: '100%', height: '80px' }}
                                placeholder="Enter Auditor Recommendation"
                                onKeyDown={(e) => handleEnterKey(e, 'recommendationTextarea')}
                            />

                        </div>
                    </td>

                </tr>

            </table>
        </div>
   
    </>
    )}
        {vendorId && (
 <MonthlyReport showModal={showModal} onClose={handleClose}   selectedMonth={selectedMonth} 
  selectedYear={selectedYear} />)}
         
        </>
      
    );
};

export default MonthlyDataTableAssessor;
